var __typeError = (msg) => {
  throw TypeError(msg);
};
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateMethod = (obj, member, method) => (__accessCheck(obj, member, "access private method"), method);
var _RTEFormatter_instances, formatTable_fn;
import { Component } from "@theme/component";
class RTEFormatter extends Component {
  constructor() {
    super(...arguments);
    __privateAdd(this, _RTEFormatter_instances);
  }
  connectedCallback() {
    super.connectedCallback();
    this.querySelectorAll("table").forEach(__privateMethod(this, _RTEFormatter_instances, formatTable_fn));
  }
}
_RTEFormatter_instances = new WeakSet();
/**
 * Formats a table for easier styling
 * @param {HTMLTableElement} table
 */
formatTable_fn = function(table) {
  const wrapper = document.createElement("div");
  wrapper.classList.add("rte-table-wrapper");
  const parent = table.parentNode;
  if (parent) {
    parent.insertBefore(wrapper, table);
    wrapper.appendChild(table);
  }
};
if (!customElements.get("rte-formatter")) {
  customElements.define("rte-formatter", RTEFormatter);
}
